import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

const DashboardCard = ({ icon, title, value, color }) => {
  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "space-between",
        p: 4,
      }}
      elevation={5}
    >
      <Typography sx={{ fontSize: 80, fontWeight: "bolder" }}>
        {value}
      </Typography>
      <Box sx={{ textAlign: "right" }}>
        <Box sx={{ mb: 3 }}>{icon}</Box>
        <Typography variant="h6" color={color}>
          {title}
        </Typography>
      </Box>
    </Paper>
  );
};
export default DashboardCard;
